import { p } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'cascading-scara-bot',
  title: 'Cascading SCARA Bot',
  summary: '3D-printable cascading SCARA arm.',
  cover: { src: '/assets/scara-rendered.png', alt: 'Rendered cascading SCARA robot arm' },
  tags: ['CAD', 'Robotics'],
  status: 'wip',
  order: 1,
  blocks: [
    p('Selective Compliant Axis Robotic Arm is a type of industrial robotic arm that deviates from the traditional jointed design by having two rotary axes to facilitate movement across XY and an independent rigid axis for Z typically driven with a lead screw.'),

    p('The problem with pre-existing 3D-Printed robotic arms is the use of jointed arm which adds complexity and intricacies with mapping the inverse kinematics. One robotic arm that I came across was the SCARA robot, these robotic arms are selectively compliance with a rigid Z-Axis and two compliant rotary axes. This design allows more flexibility for mapping out the precision.'),
  ],
}

export default project
